import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdatePrestacionEmpleadosHogarByID = () => {
  const [loadingUpdatePrestacionEmpleadosHogarById, setLoadingCreatePrestacionEmpleadosHogar] = useState(false);
  const [successUpdatePrestacionEmpleadosHogarById, setSuccessCreatePrestacionEmpleadosHogar] = useState(false);
  const [errorUpdatePrestacionEmpleadosHogarById, setErrorCreatePrestacionEmpleadosHogar] = useState(null);
  const [dataUpdatePrestacionEmpleadosHogarById, setDataPrestacionEmpleadosHogar] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updatePrestacionEmpleadosHogarById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionEmpleadosHogar(true);
    setSuccessCreatePrestacionEmpleadosHogar(false);
    setErrorCreatePrestacionEmpleadosHogar(null);

   
    apiRecord.updateCertificadoPrestacionEmpleoHogarByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionEmpleadosHogar(false);
        setSuccessCreatePrestacionEmpleadosHogar(true);
        setDataPrestacionEmpleadosHogar(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionEmpleadosHogar(false);
        setErrorCreatePrestacionEmpleadosHogar(err.response?.data);
      });
  };

  return {
    updatePrestacionEmpleadosHogarById,
    loadingUpdatePrestacionEmpleadosHogarById,
    successUpdatePrestacionEmpleadosHogarById,
    errorUpdatePrestacionEmpleadosHogarById,
    dataUpdatePrestacionEmpleadosHogarById
  };
};

export default useUpdatePrestacionEmpleadosHogarByID;
